import { render, staticRenderFns } from "./hotGamePush.vue?vue&type=template&id=227816e3&scoped=true&"
import script from "./hotGamePush.vue?vue&type=script&lang=js&"
export * from "./hotGamePush.vue?vue&type=script&lang=js&"
import style0 from "./hotGamePush.vue?vue&type=style&index=0&id=227816e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227816e3",
  null
  
)

export default component.exports